import React, { Component } from 'react'
import PropTypes from 'prop-types'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import MessageOptionsModal from '../MessageOptionsModal'
import styles from '../styles/MessageOptionsButton'

const MessageOptionsButton = ({
  closeOptionsModal,
  isBlastMsg,
  isEmail,
  hideImgPicker,
  previewPendingMedia,
  handleTemplateSelection,
  openOptionsModal,
  openCreateTemplateModal,
  createModalOpen,
  optionsModalOpen,
  templateSettings,
}) => (
  <div>
    <FloatingActionButton
      mini
      style={styles.optionsButton}
      onClick={openOptionsModal}
    >
      +
    </FloatingActionButton>
    {optionsModalOpen && (
      <MessageOptionsModal
        openCreateTemplateModal={openCreateTemplateModal}
        createModalOpen={createModalOpen}
        closeOptionsModal={closeOptionsModal}
        handleTemplateSelection={handleTemplateSelection}
        hideImgPicker={hideImgPicker}
        isBlastMsg={isBlastMsg}
        isEmail={isEmail}
        previewPendingMedia={previewPendingMedia}
        templateSettings={templateSettings}
      />
    )}
  </div>
)

MessageOptionsButton.propTypes = {
  closeOptionsModal: PropTypes.func.isRequired,
  openOptionsModal: PropTypes.func.isRequired,
  optionsModalOpen: PropTypes.bool,
  handleTemplateSelection: PropTypes.func,
  hideImgPicker: PropTypes.bool,
  isBlastMsg: PropTypes.bool,
  isEmail: PropTypes.bool,
  previewPendingMedia: PropTypes.func,
  openCreateTemplateModal: PropTypes.func,
  createModalOpen: PropTypes.bool,
  templateSettings: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
}

export default MessageOptionsButton



// WEBPACK FOOTER //
// ./src/components/Messages/MessagesEditor/MessageOptionsButton.js